/* dynamic-layout-project-highlight-card.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./dynamic-layout-project-highlight-card.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { cx } from '@atlaskit/css';
import { Box, Inline, Stack, Text } from '@atlaskit/primitives/compiled';
var styles = {
  container: "_2rko12b0 _1h6d1l7x _189ee4h9 _1dqonqa1 _1bsbaq3k _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
  summaryBox: "_p12f1wdt"
};
export var DynamicLayoutProjectHighlightCard = function DynamicLayoutProjectHighlightCard(_ref) {
  var _component$attributes, _component$attributes2;
  var component = _ref.component;
  var title = (component === null || component === void 0 || (_component$attributes = component.attributes) === null || _component$attributes === void 0 ? void 0 : _component$attributes.title) || '';
  var text = (component === null || component === void 0 || (_component$attributes2 = component.attributes) === null || _component$attributes2 === void 0 ? void 0 : _component$attributes2.content) || '';
  return title || text ? /*#__PURE__*/React.createElement(Inline, {
    xcss: cx(styles.container),
    space: "space.200",
    alignBlock: "center"
  }, /*#__PURE__*/React.createElement(Stack, {
    space: "space.050"
  }, title && /*#__PURE__*/React.createElement(Text, {
    weight: "bold",
    size: "small",
    maxLines: 1
  }, title.toLocaleUpperCase()), text && /*#__PURE__*/React.createElement(Box, {
    xcss: styles.summaryBox
  }, /*#__PURE__*/React.createElement(Text, {
    color: "color.text.subtle",
    maxLines: 1
  }, text)))) : null;
};